module.exports = __webpack_public_path__ + "img/bicycle-bike.af6e41f5.svg";